var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { BoostPortalHeader } from '../components/BoostPortalHeader';
import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { BoostStatus } from '../components/common/BoostStatus';
let BoostPortalNotFoundView = class BoostPortalNotFoundView extends LitElement {
    static get is() {
        return 'boost-portal-not-found-view';
    }
    static get styles() {
        return css `
            .text {
                text-align: center;
                padding: 40px 0;
                font-size: 120%;
            }
        `;
    }
    /** @override */ render() {
        return html `
            <boost-portal-header></boost-portal-header>
            <boost-status type="unknown">Denne siden finnes ikke</boost-status>
        `;
    }
};
BoostPortalNotFoundView._deps = [BoostStatus, BoostPortalHeader];
BoostPortalNotFoundView = __decorate([
    customElement(BoostPortalNotFoundView.is)
], BoostPortalNotFoundView);
export { BoostPortalNotFoundView };
